import { render, staticRenderFns } from "./M2hPassword.vue?vue&type=template&id=9cd4ba28&scoped=true&"
import script from "./M2hPassword.vue?vue&type=script&lang=js&"
export * from "./M2hPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd4ba28",
  null
  
)

export default component.exports